import {RemoteGetHealthProviderLocation} from 'data/usecases/private/booking-flow/health';
import {GetHealthProviderLocation} from 'domain/usecases/private/booking-flow/health';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthProviderLocation = (): GetHealthProviderLocation =>
	new RemoteGetHealthProviderLocation(
		makeBFFApiUrl(BookingFlowEndPoints.healthProviderLocation),
		makeAuthorizeHttpClientDecorator(),
	);
